/* KB upgrade layer JS, staging 24 Oct 2026. No libraries. ~3KB.
   Contract: nothing is ever hidden unless this script is running, the visitor
   allows motion, the element starts BELOW the fold, and an observer is watching it.
   A watchdog reveals everything after 3s no matter what. */
(function(){
  'use strict';
  var d=document, w=window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn){ if(d.readyState!=='loading'){fn();} else {d.addEventListener('DOMContentLoaded',fn);} }

  ready(function(){
    if(!d.querySelector('.kb-progress')){ var pb=d.createElement('div'); pb.className='kb-progress'; pb.setAttribute('aria-hidden','true'); d.body.appendChild(pb); }

    var counters=[].slice.call(d.querySelectorAll('[data-kb-count]'));
    function runCount(el){
      if(el.__kbDone) return; el.__kbDone=true;
      var target=parseFloat(el.getAttribute('data-kb-count'))||0, dec=(String(target).split('.')[1]||'').length;
      var suffix=el.getAttribute('data-kb-suffix')||'', t0=null, dur=1400;
      function step(t){ if(!t0) t0=t; var p=Math.min((t-t0)/dur,1), e=1-Math.pow(1-p,3);
        el.textContent=(target*e).toFixed(dec)+suffix; if(p<1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }

    var sel='.kb-sec .kb-reveal, .glabe_soon .col-md-6, .homepage-collection-grid-inner, .kbgr-quote, .team-member, .kbr-plan, .choice, .pillar, .step';
    var targets=reduce?[]:[].slice.call(d.querySelectorAll(sel));

    if(!('IntersectionObserver' in w)){ return; }

    var vh=w.innerHeight||800, pending=[];
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting) return;
        var el=en.target;
        if(el.hasAttribute('data-kb-count')){ if(!reduce) runCount(el); }
        else { el.classList.add('kb-in'); el.classList.remove('kb-pre'); }
        io.unobserve(el);
      });
    },{rootMargin:'0px 0px -8% 0px',threshold:0.12});

    try{
      targets.forEach(function(el){
        var r=el.getBoundingClientRect();
        if(r.top>vh*0.92 && r.height>0){ pending.push(el); }
      });
      pending.forEach(function(el,i){
        el.style.transitionDelay=((i%4)*70)+'ms';
        el.classList.add('kb-pre'); io.observe(el);
      });
    }catch(e){ pending.forEach(function(el){el.classList.remove('kb-pre');}); }

    if(!reduce){
      counters.forEach(function(c){
        var r=c.getBoundingClientRect();
        if(r.top<vh && r.bottom>0){ runCount(c); } else { io.observe(c); }
      });
    }

    setTimeout(function(){
      [].slice.call(d.querySelectorAll('.kb-pre')).forEach(function(el){
        if(el.getBoundingClientRect().top<w.innerHeight){ el.classList.add('kb-in'); el.classList.remove('kb-pre'); }
      });
    },3000);

    var hero=d.querySelector('.hero-video'), media=hero&&hero.querySelector('.hero-video--media');
    if(media && !reduce && fine){
      var ticking=false;
      var px=function(){ ticking=false; var y=w.scrollY||w.pageYOffset; if(y>hero.offsetHeight*1.2) return;
        media.style.transform='translate3d(0,'+(y*0.28).toFixed(1)+'px,0)'; };
      w.addEventListener('scroll',function(){ if(!ticking){ ticking=true; requestAnimationFrame(px);} },{passive:true});
    }

    [].slice.call(d.querySelectorAll('.kb-ticker__track')).forEach(function(t){
      var half=t.scrollWidth/2; t.style.setProperty('--kb-marquee-dur', Math.max(24, Math.round(half/45))+'s');
    });
  });
})();
